"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerState = void 0;
var PlayerState;
(function (PlayerState) {
    PlayerState["Online"] = "online";
    PlayerState["Offline"] = "offline";
})(PlayerState || (exports.PlayerState = PlayerState = {}));
